import React from 'react';
import { Loader2 } from 'lucide-react';

interface SubmitButtonProps {
  isSubmitting?: boolean;
}

export function SubmitButton({ isSubmitting }: SubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={isSubmitting}
      className="w-full bg-rose-500 text-white py-3 rounded-lg hover:bg-rose-600 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
    >
      {isSubmitting ? (
        <>
          <Loader2 className="w-5 h-5 mr-2 animate-spin" />
          Joining...
        </>
      ) : (
        'Join the Waitlist'
      )}
    </button>
  );
}